import React from 'react'
import Config from '../../config'
import UploadActions from '../../actions/upload-actions'
import SelectorActions from '../../actions/selector-actions'
import UploadStore from '../../stores/upload-store'
import OrderStore from '../../stores/order-store'
import AdobeAnalytics from '../../utils/adobe-analytics'
import compact from "lodash/compact"
import OpeOrderItem from '../../objects/opeorderitem'
import OpeImageLocal from '../../objects/opeimage/local'
import UserStore from '../../stores/user-store'
import Uploader from '../../utils/uploader'
import ProductCalculations from '../../utils/product-calculations'
import createReactClass from 'create-react-class'

var StandardUploader = createReactClass({
    filesSelected: function () {
        this.addFilesToUploadQueue(document.getElementById("fileUploadInput").files);
    },

    addFilesToUploadQueue: function (files) {

        //If one adds too many files, remove them and give an error
        if (files.length > Config.UploadSettings.maxNumberOfFiles || (UploadStore.getData().totalImagesToUpload + files.length) > Config.UploadSettings.maxNumberOfFiles) {

            logToCentralServer("StandardUploader.addFilesToUploadQueue() the maximum allowed number of photos exceeded", files.length, 1);
            UploadActions.addUploadError(_("The maximum allowed number of photos is %s but you can add multiple orders to one cart and buy all your photos at once. To order more, add this order to your cart then return to the editor.", Config.UploadSettings.maxNumberOfFiles));
            return;
        }

        Uploader.addFiles(files);

        AdobeAnalytics.photosImportedFromDevice(files.length)
    },
    openFileBrowser: function () {
        var fileInput = document.getElementById("fileUploadInput");
        if (fileInput) {
            fileInput.value = null;
            fileInput.click();
        }
    },
    isDragDropSupportedByBrowser: function () {
        var div = document.createElement('div');
        return ('draggable' in div) || ('ondragstart' in div && 'ondrop' in div);
    },
    showInitial: function () {
        return OrderStore.getItems().length === 0;
    },
    componentDidMount: function () {
        if (this.isDragDropSupportedByBrowser) {
            var self = this;
            var filedrop = document.getElementById('uploadControls');
            filedrop.addEventListener("drop", function (e) {
                e.stopPropagation();
                e.preventDefault();
                var files = e.target.files || e.dataTransfer.files;
                self.addFilesToUploadQueue(files);
            }.bind(self), false);

            filedrop.addEventListener("dragover", function (e) {
                e.stopPropagation();
                e.preventDefault();
            }, false);

            filedrop.addEventListener("dragleave", function (e) {
                e.stopPropagation();
                e.preventDefault();
            }, false);
        }
    },
    render: function () {

        var className = "ope-uploader";
        if (this.showInitial()) {
            className += " ope-uploader--initial";
        }

        return (
            <div className={className} id="ope-uploader">
                <div id="uploadControls">
                    <input type="file" multiple="multiple" accept={Config.UploadSettings.mimeTypes.join(',')}
                           style={{display: 'none'}} id="fileUploadInput" onChange={this.filesSelected}/>
                    <div id="uploadBrowseButton" onClick={this.openFileBrowser}>
                        {this.props.initial ?
                            <span>{_("Get started! Upload some photos")}</span> :
                            <span>{_("Upload more photos")}</span>
                        }
                        <span className="ope-uploader__icon" id="uploader-icon"></span>
                    </div>

                </div>
            </div>
        );


    }
});

export default StandardUploader;
